import { Colors } from '../../theme'

export default {
  marginRight: 10,
  borderBottom: `2px solid ${Colors.Palette.iconBorderColor}`
}



// WEBPACK FOOTER //
// ./src/styles/icons/bordered.js